import { useParams } from "react-router-dom";
import { CaseArticlePage } from "@/components/case-article/CaseArticlePage";

export default function CaseArticle() {
  const { slug } = useParams<{ slug: string }>();
  if (!slug) return null;
  return <CaseArticlePage slug={slug} />;
}
